import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { SITE_CATEGORY } from '../../config/sites';
import DevicesInfoChip from '../DevicesInfoChip';
import MobileVideoStatus from '../MobileVideoStatus';
import { getStyles } from '../MobileVideoStatus/helpers';

const SiteStatus = ({ licenceModel, siteCategory }) => {
  const styles = useMemo(() => getStyles(false, licenceModel, false), [licenceModel]);

  if (siteCategory === SITE_CATEGORY.ACCESS_COMMANDER_REMOTE) {
    return <span>–</span>;
  }

  return (
    <DevicesInfoChip
      error={styles === 'error'}
      label={<MobileVideoStatus licenceModel={licenceModel} showDate={false} />}
      size="small"
      success={styles === 'success'}
      variant="outlined"
      warning={styles === 'warning'}
    />
  );
};

SiteStatus.propTypes = {
  licenceModel: PropTypes.shape({}),
  siteCategory: PropTypes.string,
};

export default SiteStatus;
